import React from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";

import { toggleMobileDrawer } from "@/reducers/clientcommon";
import useIsMobile from "@/utilities/hooks/useIsMobile";

/**
 * SidebarSubLink component function.
 *
 * @param {Object} param0 - Destructured object containing type, text, href, and activeSubPage
 * @return {JSX.Element} Link component
 */
const SidebarSubLink = ({
  to,
  type,
  text,
  href,
  activeSubPage,
  handleClick,
  _className = "",
  cls = "",
}) => {
  const dispatch = useDispatch();
  const isMobile = useIsMobile();

  const getDisabledClasses = () => {
    let _link = href ? href : to;
    if (_link === "#") {
      return "opacity-30 cursor-not-allowed";
    } else {
      return "hover:bg-grey";
    }
  };

  const onLinkClick = (e) => {
    handleClick?.(e);
    // Auto-close mobile drawer on navigation
    if (isMobile) dispatch(toggleMobileDrawer(false));
  };

  return (
    <Link
      to={href ? href : to}
      className={`py- transition-linear flex h-[44px] items-center rounded-lg px-4 text-[14px] font-semibold !no-underline !duration-200 ${
        activeSubPage === type
          ? "bg-primary-100 !text-primary"
          : `text-txtColor ${getDisabledClasses()}`
      } ${cls} ${_className}`}
      onClick={onLinkClick}
    >
      {text}
    </Link>
  );
};

export default SidebarSubLink;
